module.exports = __webpack_public_path__ + "static/img/20180414165846.a0a77a87.jpg";